export default __webpack_public_path__ + "151c55d9b9e6b25ec5050c5b2c049829.svg";